var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"editor-dropdown"},[_c('span',{staticClass:"value",style:({ paddingRight: _vm.whitespace })},[_vm._v(_vm._s(_vm.value))]),_c('span',{staticClass:"dropdown"})])}
var staticRenderFns = []

export { render, staticRenderFns }